import { render, staticRenderFns } from "./DialogDingtalkScan.vue?vue&type=template&id=455271d4"
import script from "./DialogDingtalkScan.vue?vue&type=script&lang=js"
export * from "./DialogDingtalkScan.vue?vue&type=script&lang=js"
import style0 from "./DialogDingtalkScan.vue?vue&type=style&index=0&id=455271d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports